import { useAppStore, APP_MODE_CONFIGS } from '@/store/appStore'
import type { AppMode, AppModeConfig } from '@/store/appStore'

export function useAppMode() {
  const appMode = useAppStore((s) => s.appMode)
  const setAppMode = useAppStore((s) => s.setAppMode)
  const config = APP_MODE_CONFIGS[appMode]

  return {
    mode: appMode,
    config,
    setMode: setAppMode,
    isDemo: appMode === 'demo',
    isDevelopment: appMode === 'development',
    isQuality: appMode === 'quality',
    isProduction: appMode === 'production',
    isSandbox: appMode === 'sandbox',
    requiresAuth: config.requiresAuth,
    allowConfigChanges: config.allowConfigChanges,
    allowConfigPromotion: config.allowConfigPromotion,
  }
}

/** Returns mode config without reactivity — useful outside components */
export function getAppModeConfig(): { mode: AppMode; config: AppModeConfig } {
  const mode = useAppStore.getState().appMode
  return { mode, config: APP_MODE_CONFIGS[mode] }
}
